import { FilterField } from "kontrolEdge/helpers/advancedFilters";
import { FailoverTableRow } from "./Types";

export function makeOutageFields(
  isViewingAllCustomers: boolean
): FilterField<FailoverTableRow>[] {
  const fields: FilterField<FailoverTableRow>[] = [
    {
      label: "ID",
      key: "id",
      accessor: (r) => r.incidentId ?? "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Date",
      key: "date",
      accessor: (r) => r.date,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Site",
      key: "site",
      accessor: (r) => r.site ?? "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Duration",
      key: "duration",
      accessor: (r) => r.duration,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Description",
      key: "description",
      accessor: (r) => r.description,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Detail",
      key: "detail",
      accessor: (r) => r.detail ?? "",
      type: "string",
      inFreeText: true,
    },
  ];

  if (isViewingAllCustomers) {
    fields.splice(3, 0, {
      label: "Customer",
      key: "customer",
      accessor: (r) => r.customer ?? "",
      type: "string",
      inFreeText: true,
    });
  }

  return fields;
}
